type KeyValuePairString = `${string}=${string}`
function get(key: string) {
  const cookies = document.cookie
  const cookiesList: KeyValuePairString[] = cookies.split('; ') as KeyValuePairString[]
  const cookieMap = cookiesList.reduce((acc: Record<string, string>, current) => {
    const [_key, value] = current.split('=')
    acc[_key] = value
    return acc
  }, {})
  return cookieMap[key]
}

function set(key: string, value: string, expirationInDays: number) {
  const d = new Date()
  d.setDate(d.getDate() + expirationInDays)
  const expires = 'expires=' + d.toUTCString()
  document.cookie = key + '=' + value + ';' + expires
}

export default { get, set }
